import React from 'react';
import { ShieldCheck, Headset, Lock, Certificate } from '@phosphor-icons/react';

export default function TrustCompliance() {
  return (
    <section className="py-20 md:py-32 bg-[#0B132B]" data-testid="trust-compliance-section">
      <div className="w-full px-6 md:px-10 lg:px-16 xl:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Left: 24x7 Support */}
          <div className="flex flex-col justify-center text-center">
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#10B981] mb-3">
              Always-On Support
            </p>
            <h2
              className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-white mb-6"
              style={{ fontFamily: 'Chivo, sans-serif' }}
            >
              24/7 Enterprise Support
            </h2>
            <p className="text-base leading-relaxed text-slate-300 mb-8" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
              Our dedicated solutions architects are available around the clock.
              From incident response to architecture reviews, get expert guidance
              whenever you need it.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: <Headset size={24} weight="duotone" />, label: 'Dedicated Account Manager' },
                { icon: <ShieldCheck size={24} weight="duotone" />, label: 'Incident Response Team' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-3 p-4 border border-[#1E293B] bg-[#0F172A]">
                  <span className="text-[#10B981]">{item.icon}</span>
                  <span className="text-base font-medium text-slate-200">{item.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: SaaS Security */}
          <div className="flex flex-col justify-center text-center">
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#0052FF] mb-3">
              Enterprise Security
            </p>
            <h2
              className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-white mb-6"
              style={{ fontFamily: 'Chivo, sans-serif' }}
            >
              SaaS-Grade Security
            </h2>
            <p className="text-base leading-relaxed text-slate-300 mb-8" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
              Industry-leading security standards protect your data and workloads.
              Our infrastructure meets the highest compliance requirements for
              enterprise deployments.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: <Lock size={24} weight="duotone" />, label: 'End-to-End Encryption' },
                { icon: <Certificate size={24} weight="duotone" />, label: 'SOC 2 Compliance Ready' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-3 p-4 border border-[#1E293B] bg-[#0F172A]">
                  <span className="text-[#0052FF]">{item.icon}</span>
                  <span className="text-base font-medium text-slate-200">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Trust image */}
        <div className="mt-16 relative overflow-hidden border border-[#1E293B]">
          <img
            src="https://images.unsplash.com/photo-1712159018726-4564d92f3ec2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxjdXN0b21lciUyMHN1cHBvcnQlMjB0ZWNofGVufDB8fHx8MTc3NjA4MDI5OHww&ixlib=rb-4.1.0&q=85"
            alt="Enterprise support team"
            className="w-full h-48 sm:h-64 object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B132B]/70 to-[#0B132B]/40 flex items-center justify-center">
            <div className="text-center">
              <p className="text-white font-bold text-xl sm:text-2xl" style={{ fontFamily: 'Chivo, sans-serif' }}>
                Trusted by enterprises across the globe
              </p>
              <p className="text-slate-300 text-base mt-1">USA & India operations center</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
